import React, { memo,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { dateFormat, compareDateWithCurrent, utcDateTimeWithTimeZoneWithFormat } from "../../services/Util";
import Constants from "../../Constants";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { CrossIconForModal, WatchIcon } from "../../AppIcons";
import DateFormat from "../../pages/DateFormat";
const RightModal = memo((props) => {
  const { t } = useTranslation();
  const translate = t;

  function hideRightModel() {
    document.body.classList.remove("modal-open");
    if ($('#active_day').length) {
      $('#active_day').trigger('focus');
      $('#active_day').removeAttr('id');
    }
  }
  const selectedTaskDetailRedux = useSelector(
    (tasksSameDate) => tasksSameDate.tasks_same_date
  ).value;
  const navigate = useNavigate();

  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;

  const rightModelStatusRedux = useSelector(
    (rightModelStatus) => rightModelStatus.right_model_status
  ).value;

  $(document).on("keydown", function (event) {
    if(rightModelStatusRedux.status){
      event.preventDefault();
    }else{
    if (event.key === Constants.ESCAPE) {
      hideRightModel();
      $('#active_day').trigger('focus');
      $('#active_day').removeAttr('id');
    }
    if ($(event.target).closest('.created-task-list').is(':last-child') &&
        event.key === Constants.TAB && !event.shiftKey) {
          event.preventDefault();
          $('.close').trigger('focus');
    } else if ($(event.target).hasClass('close') &&
        event.key === Constants.TAB && event.shiftKey) {
          event.preventDefault();
          $('.task-review .created-task-list:last-child .left a').trigger('focus');
    }
  }
  });

useEffect(()=>{
  document.body.classList.remove("modal-open");
    if ($('#active_day').length) {
      $('#active_day').trigger('focus');
      $('#active_day').removeAttr('id');
    }
},[]) 

const getMyTaskLink = (task) => {
  var url = "/project";
  var urlLastPart = ''
  switch (task.type.originalEnum) {
    case "CONFIGURE_PROJECT_SOURCE" : 
    url = `/${task.url.substring(1)}`;
    return (
      <Link className="linkFont100" to="" onClick={(e) => {e.preventDefault();navigate(url)}}>
        {task.displayName}
      </Link>
    );
    case "REVIEW_PROJECT_REQUEST":
      url = `/${task.url.substring(1)}`;
    return (
      <Link className="linkFont100" to="" onClick={(e) => {e.preventDefault();navigate(url)}}>
        {task.displayName}
      </Link>
    );
    case "CONFIGURE_PROJECT_WORKFLOW" : 
    url = `/${task.url.substring(1)}`;
    return (
      <Link className="linkFont100" to="" onClick={(e) => {e.preventDefault();navigate(url)}}>
        {task.displayName}
      </Link>
    );
    case "SELECT_WINNING_BID":
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'bids'}})}}>
          {task.displayName}
        </Link>
      );

    case "RESPOND_TO_CUSTOMER_INTERNAL_PROJECT_REQUEST":
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'internalTranslator'}})}}>
          {task.displayName}
        </Link>
      );
    case "SUBMIT_TM_AND_CLOSE_PROJECT" : 
    return (
      <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'overView'}})}}>
        {task.displayName}
      </Link>
    );
    case "CUSTOM" :
      url = `/${task?.url.substring(1)}`;
      urlLastPart = url.split("/").pop()  
      if(task.project !== ''){
        return (
          <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'tasks',id:urlLastPart}})}}>
            {task.displayName}
          </Link>
        );
      }else{
        var newUrl = task.url.replace("#workspace", "/campaign");
        var taskId  = url.split("/").pop()  
        return (
          <Link className="linkFont100" onClick={(e)=>{e.preventDefault();navigate(newUrl,{state:{id:taskId}})}}>
            {task.displayName}
          </Link>)
      }
     

    case "RESPOND_TO_MACHINE_TRANSLATION_QUOTE":
      url = `/${task?.url.substring(1)}`;
      urlLastPart = url.split("/").pop()
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'machineTranslation',id:urlLastPart}})}}>
          {task.displayName}
        </Link>
      );

    case "RESPOND_TO_VENDOR_CHANGE_ORDER_BID":
      url = `/${task?.url.substring(1)}`;
      urlLastPart = url.split("/").pop()
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'changeOrder',id:urlLastPart}});setTimeout(() => {$('button.active').trigger('focus')}, 300);}}>
          {task.displayName}
        </Link>
      );

    case "RESPOND_TO_CUSTOMER_CHANGE_ORDER_REQUEST":
      url = `/${task?.url.substring(1)}`;
      urlLastPart = url.split("/").pop()
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'changeOrder',id:urlLastPart}})}}>
          {task.displayName}
        </Link>
      );

    case "PROJECT_ACCEPT_CANCELLATION":
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'bids'}})}}>
          {task.displayName}
        </Link>
      );

    case "REVIEW_APPROVED_ASSET_NOTES":
      url = `/${task.url.substring(1)}`;
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(url)}}>
          {task.displayName}
        </Link>
      );

    case "REQUEST_BIDS_FOR_PROJECT":
      url = `/project/${task.project.id}`;
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(url)}}>
          {task.displayName}
        </Link>
      );

    case "REVIEW_PROJECT_ASSETS":
      url = `/${task?.url.substring(1)}`;
      var code = ''
      if(task.language !== ''){
        code = task.language.code
      }else{
        code = task?.url.split("/").pop()
      }
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'overView',langCode:code}})}}>
          {task.displayName}
        </Link>
      );

    case "DELIVER_PROJECT_ASSETS":
      url = `/${task?.url.substring(1)}`;
      if(task.language !== ''){
        code = task.language.code
      }else{
        code = task?.url.split("/").pop()
      }
      return (
        <Link className="linkFont100"  onClick={(e) => {e.preventDefault();navigate(`/project/${task.project.id}`,{state:{tab:'overView',langCode:code}})}}>
          {task.displayName}
        </Link>
      );

    case "REVISE_PROJECT_ASSETS":
      url = `/${task.url.substring(1)}`;
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(url)}}>
          {task.displayName}
        </Link>
      );

    case "ASSIGN_USERS_TO_GROUPS":
      return (
        <Link className="linkFont100" onClick={(e) => {e.preventDefault();navigate(`/settings/user-management`)}}>
          {task.displayName}
        </Link>
      );

    case "REVIEW_WORKSPACE_USER_REQUEST":
      return ( <Link className="linkFont100" onClick={(e) => { e.preventDefault(); navigate(`/campaign/${task.workspace.id}`) }}>
      {task.displayName}
    </Link>
    );

    default:
      return "";
  }
};

  return (
    <>{rightModelStatusRedux.status?"":
    <div className="right-modal" aria-labelledby="taskDate" aria-modal="true" role="dialog">
      <div className="modal-header flex">
        <div className="left flex-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
          >
            <path
              d="M15.25 18.8438H3.75C2.79688 18.8438 1.88279 18.4651 1.20884 17.7912C0.534876 17.1172 0.15625 16.2031 0.15625 15.25V5.1875C0.15625 4.23438 0.534876 3.32029 1.20884 2.64634C1.88279 1.97238 2.79688 1.59375 3.75 1.59375H15.25C16.2031 1.59375 17.1172 1.97238 17.7912 2.64634C18.4651 3.32029 18.8438 4.23438 18.8438 5.1875V15.25C18.8438 16.2031 18.4651 17.1172 17.7912 17.7912C17.1172 18.4651 16.2031 18.8438 15.25 18.8438V18.8438ZM3.75 3.03125C3.17813 3.03125 2.62968 3.25843 2.2253 3.6628C1.82093 4.06718 1.59375 4.61563 1.59375 5.1875V15.25C1.59375 15.8219 1.82093 16.3703 2.2253 16.7747C2.62968 17.1791 3.17813 17.4062 3.75 17.4062H15.25C15.8219 17.4062 16.3703 17.1791 16.7747 16.7747C17.1791 16.3703 17.4062 15.8219 17.4062 15.25V5.1875C17.4062 4.61563 17.1791 4.06718 16.7747 3.6628C16.3703 3.25843 15.8219 3.03125 15.25 3.03125H3.75Z"
              fill="white"
            />
            <path
              d="M18.125 7.34375H0.875C0.684376 7.34375 0.501559 7.26802 0.366767 7.13323C0.231975 6.99844 0.15625 6.81562 0.15625 6.625C0.15625 6.43438 0.231975 6.25156 0.366767 6.11677C0.501559 5.98198 0.684376 5.90625 0.875 5.90625H18.125C18.3156 5.90625 18.4984 5.98198 18.6332 6.11677C18.768 6.25156 18.8438 6.43438 18.8438 6.625C18.8438 6.81562 18.768 6.99844 18.6332 7.13323C18.4984 7.26802 18.3156 7.34375 18.125 7.34375Z"
              fill="white"
            />
            <path
              d="M5.90625 4.46875C5.71563 4.46875 5.53281 4.39302 5.39802 4.25823C5.26323 4.12344 5.1875 3.94062 5.1875 3.75V0.875C5.1875 0.684376 5.26323 0.501559 5.39802 0.366767C5.53281 0.231975 5.71563 0.15625 5.90625 0.15625C6.09687 0.15625 6.27969 0.231975 6.41448 0.366767C6.54927 0.501559 6.625 0.684376 6.625 0.875V3.75C6.625 3.94062 6.54927 4.12344 6.41448 4.25823C6.27969 4.39302 6.09687 4.46875 5.90625 4.46875Z"
              fill="white"
            />
            <path
              d="M13.0938 4.46875C12.9031 4.46875 12.7203 4.39302 12.5855 4.25823C12.4507 4.12344 12.375 3.94062 12.375 3.75V0.875C12.375 0.684376 12.4507 0.501559 12.5855 0.366767C12.7203 0.231975 12.9031 0.15625 13.0938 0.15625C13.2844 0.15625 13.4672 0.231975 13.602 0.366767C13.7368 0.501559 13.8125 0.684376 13.8125 0.875V3.75C13.8125 3.94062 13.7368 4.12344 13.602 4.25823C13.4672 4.39302 13.2844 4.46875 13.0938 4.46875Z"
              fill="white"
            />
          </svg>
          <strong id="taskDate" tabIndex={0}>
            <DateFormat date={selectedTaskDetailRedux[1]} />
          </strong>
        </div>
        <button
          className="close flex-center"
          aria-label="close"
          onClick={hideRightModel}
        >
          {CrossIconForModal}
        </button>
      </div>
      <div className="modal-content">
        <p className="task">
          <strong>
            {selectedTaskDetailRedux[0].length < 2
              ? translate("project_page.task")
              : translate("project_page.tasks")}{" "}
            -
          </strong>{" "}
          {selectedTaskDetailRedux[2]}
        </p>
        <div className="task-review">
          {selectedTaskDetailRedux[0] && selectedTaskDetailRedux[0].length > 0 ? selectedTaskDetailRedux[0].map((task,index) => {
            return (
              <div className="created-task-list" key={task.id}>
                <div className="list-top-content flex">
                  <div className="left">
                    {task.project !== "" || task.taskCategoryDisplay === "Campaign" ? getMyTaskLink(task) : <Link to={"/project-request/show/" + task?.projectRequest?.id}>{task.displayName}</Link>} 
                    <br/>
                    <span>
                      {task.project.name} {task.userGroup !== '' ? '('+task.userGroup.name+')': ''}
                    </span>
                    <p>
                      {translate("project_page.assigned_to")}{" "}
                      <span>{task.assigneeUserName}</span>{" "}
                    </p>
                  </div>
                  <div >
                  {task.dueDate !== "" ? (
                  <div className="right ">
          <div className="assign-due flex flex-align-center" aria-label="due today">
            {WatchIcon}
            {task?.overDue ? task?.dueToday
              ? task?.dueDate?.date + " ( Due Today ) "
              : task?.dueDate?.date + " ( Overdue ) "
              : task?.dueDate?.date}
          </div>
          </div>
        ) : (
          ""
        )}
                  </div>
                </div>
              </div>
            );
          }):Constants.BLANK}
          
        </div>
      </div>
    </div>}</>
  );
});

RightModal.propTypes = {};

export default RightModal;
